document.addEventListener("DOMContentLoaded", function () {
  const detailsPopUp = document.querySelector(".product__details__popup");
  const detailsPopUpContent = document.querySelector(".product__details__popup--content");
  const detailsPopUpOpen = document.querySelector(".product__details__content--button");
  const detailsPopUpClose = document.querySelector(".product__details__popup--close");

  [detailsPopUp,detailsPopUpClose].forEach( (htmlElement) => htmlElement?.addEventListener("click", () => {
    togglePopUp(false)
  }));
  detailsPopUpOpen?.addEventListener("click", function() {
    togglePopUp(true)
  })
  detailsPopUpContent?.addEventListener("click", function(event){
    event.stopPropagation();
  })
  function togglePopUp(isVisible = false) {
    if (!detailsPopUp) return;
    detailsPopUp.classList.toggle("product__details__popup--active",isVisible);
    document.body.classList.toggle("disabled--scroll", isVisible)
  }
  


  const itemsIngredients = document.querySelectorAll(".product__ingredients-item");
  itemsIngredients.forEach( ingredient => ingredient.addEventListener("click", srollToElement))

  function srollToElement() {
    const ingridientsSection = document.querySelector(".ingridients");
    const header = document.querySelector("sticky-header");
    if (!ingridientsSection && !header) return;
    const headerHeight = header.getBoundingClientRect().height || 0;
    ingridientsSection.style.scrollMarginTop = headerHeight + "px"
    ingridientsSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
  }

  const productDetails = document.querySelector(".product__details--content[data-dropdown='true']"); 
  productDetails?.addEventListener("click", function(event) {
    const {target} = event;
    if (target.classList.contains("product__details__faq-answer")) {
      const offset = 13;
      const heightParentElement = Number(productDetails.scrollHeight) + offset;
      const { parentElement, nextElementSibling } = target;
      const { scrollHeight } = nextElementSibling;
      const isOpen = parentElement.dataset.open === "false" ? true : false;

      productDetails.style.maxHeight = isOpen ? Number(scrollHeight) + heightParentElement + "px" : heightParentElement + "px";
      nextElementSibling.style.maxHeight = isOpen ? scrollHeight * 2 + "px" : 0;
      parentElement.setAttribute("data-open", String(isOpen))
      target.classList.toggle("product__details__faq-item--active",isOpen)
    }
  })
})